import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
var timeoutHandle;

export default {
  props: ["mySpace"],
  /*
      Defines the data used by the component
    */
  data() {
    return {
      successend: false,
      name: "",
      error: false,
      company: this.$store.state.company,
    };
  },
  created() {
    setTimeout(() => {
      if (this.$refs.collectionname) {
        this.$refs.collectionname.focus();
      }
    }, 300);
  },
  methods: {
    addCollection() {
      this.error = false;
      let self = this;
      let formData = new FormData();

      formData.append("name", this.name);

      this.$axios
        .post(baseUrl + "/collectionnew", formData)
        .then((response) => {
          if (
            response.data.success == false &&
            response.data.msg == "collection_exists"
          ) {
            this.error = true;
          } else {
            //close all actions
            EventBus.$emit(`closeallactions`);

            //update collectionList
            EventBus.$emit(`collections`);

            //update collections tree
            EventBus.$emit(`collection-tree-update`);
          }
        });
      window.clearTimeout(timeoutHandle);
      timeoutHandle = window.setTimeout(function () {
        self.error = false;
      }, 7500);
    },
  },
};
